import Api from './api';

export default {
  getConfigs: () => Api.get('configs'),
  updateConfigs: (data) => Api.post('configs', data),
};
